module.exports = __webpack_public_path__ + "static/media/ios-trending-up.e1fa1846.svg";